import React from 'react';
import { Outlet } from 'react-router-dom';
import { useTheme, useMediaQuery } from '@mui/material';
import DesktopLayout from './DesktopLayout';

/**
 * Generic desktop shell for full-page routes (Leads, Clients, Settings, etc.)
 * mode="page": sidebar nav (64px) + centered scrollable content area
 *
 * On mobile: transparent — renders <Outlet /> directly.
 */
const PageDesktopShell = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  if (!isDesktop) {
    return <Outlet />;
  }

  return (
    <DesktopLayout mode="page">
      <Outlet />
    </DesktopLayout>
  );
};

export default PageDesktopShell;
